module.exports = __webpack_public_path__ + "static/media/Chatbot2.e77b9a26.jpg";